var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "folder_open_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.271,
    height: 48.271,
    viewBox: "0 0 48.271 48.271",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_75",
    "data-name": "Trac\\xE9 75",
    d: "M0,0H48.271V48.271H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_76",
    "data-name": "Trac\\xE9 76",
    d: "M38.2,8.023H22.113L18.09,4H6.023a4.017,4.017,0,0,0-4,4.023L2,32.158a4.034,4.034,0,0,0,4.023,4.023H38.2a4.034,4.034,0,0,0,4.023-4.023V12.045A4.034,4.034,0,0,0,38.2,8.023Zm0,24.136H6.023V12.045H38.2Z",
    transform: "translate(2.023 4.045)",
    fill: "#002b53"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/folder-icon.c29bb815057ff6c0272b7289125d5ed3.svg";
export { ForwardRef as ReactComponent };